module.exports = __webpack_public_path__ + "img/5.30bf022c.jpg";